var map = {
	"./adb": 3519,
	"./adb.ts": 3519,
	"./apt": 2185,
	"./apt.ts": 2185,
	"./basename": 4330,
	"./basename.ts": 4330,
	"./brew": 804,
	"./brew.ts": 804,
	"./bundle": 4500,
	"./bundle.ts": 4500,
	"./cat": 4454,
	"./cat.ts": 4454,
	"./chmod": 5027,
	"./chmod.ts": 5027,
	"./chown": 3943,
	"./chown.ts": 3943,
	"./clear": 8563,
	"./clear.ts": 8563,
	"./cp": 9012,
	"./cp.ts": 9012,
	"./curl": 2858,
	"./curl.ts": 2858,
	"./cut": 8498,
	"./cut.ts": 8498,
	"./date": 6008,
	"./date.ts": 6008,
	"./dd": 452,
	"./dd.ts": 452,
	"./df": 8574,
	"./df.ts": 8574,
	"./diff": 6443,
	"./diff.ts": 6443,
	"./dig": 6298,
	"./dig.ts": 6298,
	"./dirname": 4846,
	"./dirname.ts": 4846,
	"./docker": 5708,
	"./docker-compose": 581,
	"./docker-compose.ts": 581,
	"./docker.ts": 5708,
	"./dotnet": 4634,
	"./dotnet.ts": 4634,
	"./du": 7363,
	"./du.ts": 7363,
	"./echo": 6189,
	"./echo.ts": 6189,
	"./env": 3965,
	"./env.ts": 3965,
	"./export": 1218,
	"./export.ts": 1218,
	"./fdisk": 6537,
	"./fdisk.ts": 6537,
	"./find": 443,
	"./find.ts": 443,
	"./fmt": 3713,
	"./fmt.ts": 3713,
	"./fold": 1051,
	"./fold.ts": 1051,
	"./go": 5754,
	"./go.ts": 5754,
	"./grep": 8160,
	"./grep.ts": 8160,
	"./head": 7170,
	"./head.ts": 7170,
	"./htop": 1319,
	"./htop.ts": 1319,
	"./id": 6137,
	"./id.ts": 6137,
	"./jq": 765,
	"./jq.ts": 765,
	"./kill": 6856,
	"./kill.ts": 6856,
	"./killall": 6825,
	"./killall.ts": 6825,
	"./less": 9089,
	"./less.ts": 9089,
	"./ln": 3374,
	"./ln.ts": 3374,
	"./ls": 3137,
	"./ls.ts": 3137,
	"./lsblk": 2294,
	"./lsblk.ts": 2294,
	"./lsof": 7784,
	"./lsof.ts": 7784,
	"./mkdir": 1617,
	"./mkdir.ts": 1617,
	"./more": 9241,
	"./more.ts": 9241,
	"./mount": 4107,
	"./mount.ts": 4107,
	"./mv": 9819,
	"./mv.ts": 9819,
	"./nano": 9662,
	"./nano.ts": 9662,
	"./nl": 9014,
	"./nl.ts": 9014,
	"./node": 2940,
	"./node.ts": 2940,
	"./npm": 3179,
	"./npm.ts": 3179,
	"./nvm": 1873,
	"./nvm.ts": 1873,
	"./od": 4127,
	"./od.ts": 4127,
	"./paste": 1,
	"./paste.ts": 1,
	"./ping": 1848,
	"./ping.ts": 1848,
	"./pkill": 8766,
	"./pkill.ts": 8766,
	"./pnpm": 9861,
	"./pnpm.ts": 9861,
	"./ps": 6858,
	"./ps.ts": 6858,
	"./pwd": 6717,
	"./pwd.ts": 6717,
	"./python": 790,
	"./python.ts": 790,
	"./python3": 6293,
	"./python3.ts": 6293,
	"./readlink": 1272,
	"./readlink.ts": 1272,
	"./rm": 7457,
	"./rm.ts": 7457,
	"./rmdir": 1470,
	"./rmdir.ts": 1470,
	"./rsync": 9051,
	"./rsync.ts": 9051,
	"./ruby": 1724,
	"./ruby.ts": 1724,
	"./ruff": 9941,
	"./ruff.ts": 9941,
	"./scp": 2667,
	"./scp.ts": 2667,
	"./sed": 3906,
	"./sed.ts": 3906,
	"./seq": 8085,
	"./seq.ts": 8085,
	"./shred": 7236,
	"./shred.ts": 7236,
	"./sort": 2256,
	"./sort.ts": 2256,
	"./source": 7873,
	"./source.ts": 7873,
	"./split": 4354,
	"./split.ts": 4354,
	"./ssh": 1968,
	"./ssh.ts": 1968,
	"./stat": 1990,
	"./stat.ts": 1990,
	"./su": 8308,
	"./su.ts": 8308,
	"./sudo": 2493,
	"./sudo.ts": 2493,
	"./tac": 702,
	"./tac.ts": 702,
	"./tail": 6226,
	"./tail.ts": 6226,
	"./tar": 8357,
	"./tar.ts": 8357,
	"./tee": 4580,
	"./tee.ts": 4580,
	"./time": 4013,
	"./time.ts": 4013,
	"./top": 7989,
	"./top.ts": 7989,
	"./touch": 1489,
	"./touch.ts": 1489,
	"./tr": 1778,
	"./tr.ts": 1778,
	"./traceroute": 166,
	"./traceroute.ts": 166,
	"./tree": 5908,
	"./tree.ts": 5908,
	"./truncate": 7750,
	"./truncate.ts": 7750,
	"./uname": 5746,
	"./uname.ts": 5746,
	"./uniq": 6353,
	"./uniq.ts": 6353,
	"./unzip": 9728,
	"./unzip.ts": 9728,
	"./vim": 1462,
	"./vim.ts": 1462,
	"./wc": 1582,
	"./wc.ts": 1582,
	"./wget": 5619,
	"./wget.ts": 5619,
	"./where": 6897,
	"./where.ts": 6897,
	"./whereis": 5145,
	"./whereis.ts": 5145,
	"./which": 2179,
	"./which.ts": 2179,
	"./who": 8382,
	"./who.ts": 8382,
	"./xargs": 7155,
	"./xargs.ts": 7155,
	"./xxd": 3482,
	"./xxd.ts": 3482,
	"./yarn": 9914,
	"./yarn.ts": 9914,
	"./yo": 5440,
	"./yo.ts": 5440,
	"./zip": 3869,
	"./zip.ts": 3869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4534;